// Original Instagram bio templates. Placeholders: {name} {city} {job} {hobby}
export const BIO_CATEGORIES = [
  { id: 'all', label: 'Tous' },
  { id: 'aesthetic', label: 'Aesthetic' },
  { id: 'love', label: 'Amour' },
  { id: 'travel', label: 'Voyage' },
  { id: 'business', label: 'Business' },
  { id: 'funny', label: 'Drôle' },
  { id: 'minimal', label: 'Minimal' },
];

export const BIO_TEMPLATES = [
  { id: 'a1', cat: 'aesthetic', lines: ['✧ {name} ✧', 'chasing golden hours & soft moments', '📍 {city}'] },
  { id: 'a2', cat: 'aesthetic', lines: ['☾ {name}', 'coffee • {hobby} • daydreams', 'living in lowercase'] },
  { id: 'a3', cat: 'aesthetic', lines: ['˚₊‧ {name} ‧₊˚', 'collecting sunsets, not things', '✿ {city}'] },
  { id: 'a4', cat: 'aesthetic', lines: ['{name} 🌸', 'soft heart, wild mind', '{hobby} is my therapy'] },
  { id: 'l1', cat: 'love', lines: ['♡ {name} ♡', 'loved deeply, loving louder', 'grateful for every little thing'] },
  { id: 'l2', cat: 'love', lines: ['{name} 💌', 'writing my own love story', 'one page at a time'] },
  { id: 'l3', cat: 'love', lines: ['✨ {name} ✨', 'kindness is my favourite outfit', '🤍 {city}'] },
  { id: 't1', cat: 'travel', lines: ['🌍 {name}', 'passport full, heart fuller', 'home base: {city} ✈️'] },
  { id: 't2', cat: 'travel', lines: ['{name} ⛰️', 'next stop: anywhere', '{hobby} lover • map collector'] },
  { id: 't3', cat: 'travel', lines: ['☀️ {name}', 'salt in my hair, sand in my shoes', 'from {city} to everywhere'] },
  { id: 'b1', cat: 'business', lines: ['{name} | {job}', 'helping you grow, one idea at a time', '📍 {city} • DM for collabs'] },
  { id: 'b2', cat: 'business', lines: ['✦ {name} ✦', '{job} & creator', '📩 bookings open'] },
  { id: 'b3', cat: 'business', lines: ['{name} 💼', 'building something I believe in', '{job} based in {city}'] },
  { id: 'f1', cat: 'funny', lines: ['{name} 🍕', 'professional snack tester', 'part-time {hobby} expert'] },
  { id: 'f2', cat: 'funny', lines: ['{name} 😴', 'running on coffee and vibes', 'my plants are still alive, somehow'] },
  { id: 'f3', cat: 'funny', lines: ['{name} 🤷', 'I came, I saw, I forgot why I came', '📍 lost somewhere in {city}'] },
  { id: 'm1', cat: 'minimal', lines: ['{name}', '{job} · {city}'] },
  { id: 'm2', cat: 'minimal', lines: ['{name}.', 'less, but better.'] },
  { id: 'm3', cat: 'minimal', lines: ['— {name} —', '{hobby} / {city}'] },
];

export const IG_BIO_LIMIT = 150;

// Modèles originaux en français
export const BIO_TEMPLATES_FR = [
  { id: 'fa1', cat: 'aesthetic', lines: ['✧ {name} ✧', 'chasseuse de lumière dorée', '📍 {city}'] },
  { id: 'fa2', cat: 'aesthetic', lines: ['☾ {name}', 'café • {hobby} • rêveries', 'la vie en douceur'] },
  { id: 'fa3', cat: 'aesthetic', lines: ['˚₊‧ {name} ‧₊˚', 'je collectionne les couchers de soleil', '✿ {city}'] },
  { id: 'fa4', cat: 'aesthetic', lines: ['{name} 🌸', 'cœur tendre, esprit libre', '{hobby}, ma thérapie'] },
  { id: 'fl1', cat: 'love', lines: ['♡ {name} ♡', 'aimer fort, rire encore plus fort', 'merci la vie'] },
  { id: 'fl2', cat: 'love', lines: ['{name} 💌', "j'écris ma propre histoire", 'une page à la fois'] },
  { id: 'fl3', cat: 'love', lines: ['✨ {name} ✨', 'la gentillesse, ma plus belle tenue', '🤍 {city}'] },
  { id: 'ft1', cat: 'travel', lines: ['🌍 {name}', 'passeport plein, cœur encore plus', 'camp de base : {city} ✈️'] },
  { id: 'ft2', cat: 'travel', lines: ['{name} ⛰️', 'prochaine destination : ailleurs', 'fan de {hobby} • collectionneur de cartes'] },
  { id: 'ft3', cat: 'travel', lines: ['☀️ {name}', 'du sel dans les cheveux, du sable partout', 'de {city} au bout du monde'] },
  { id: 'fb1', cat: 'business', lines: ['{name} | {job}', 'je vous aide à faire grandir vos idées', '📍 {city} • DM pour collabs'] },
  { id: 'fb2', cat: 'business', lines: ['✦ {name} ✦', '{job} & créatrice de contenu', '📩 réservations ouvertes'] },
  { id: 'fb3', cat: 'business', lines: ['{name} 💼', "je construis ce en quoi je crois", '{job} basé(e) à {city}'] },
  { id: 'ff1', cat: 'funny', lines: ['{name} 🥐', 'testeuse officielle de croissants', 'experte en {hobby} à mi-temps'] },
  { id: 'ff2', cat: 'funny', lines: ['{name} 😴', 'je fonctionne au café et aux bonnes ondes', 'mes plantes survivent, par miracle'] },
  { id: 'ff3', cat: 'funny', lines: ['{name} 🤷', "je suis venu(e), j'ai vu, j'ai oublié pourquoi", '📍 perdu(e) quelque part à {city}'] },
  { id: 'fm1', cat: 'minimal', lines: ['{name}', '{job} · {city}'] },
  { id: 'fm2', cat: 'minimal', lines: ['{name}.', 'moins, mais mieux.'] },
  { id: 'fm3', cat: 'minimal', lines: ['— {name} —', '{hobby} / {city}'] },
];
